import { FC, Suspense } from 'react';
import UserPostSection from './post';
import UserCampaignSection from './campaign';
import UserDescriptionSection from './description';
import { UserBodySkeleton } from '~/skeleton/user';
// import UserRelatedSection from './related-user';
import { useAtomValue } from 'jotai';
import { $CurrentUser } from '../shared/atoms/current-user';
import { UserDetailUtil } from 'shared/models';
import { NotFound } from '~/components/not-found';
import { UserSilentAwaken } from './user-silent-awaken';

export const UserBody: FC = () => {
  const currentUser = useAtomValue($CurrentUser);
  const isAvailable = UserDetailUtil.isUserAvailable(currentUser);

  if (!isAvailable) {
    return <NotFound />;
  }

  return (
    <>
      <UserSilentAwaken />
      <UserDescriptionSection />
      <Suspense fallback={<UserBodySkeleton />}>
        <UserPostSection />
        {/* <UserRelatedSection /> */}
        {/* <UserCampaignSection /> */}
      </Suspense>
    </>
  );
};
